import React, { Component } from "react";
import Scrollbar from "react-scrollbars-custom";
import { toast } from "react-toastify";
import {
  Select,
  Button,
  Tooltip,
  Input,
} from "antd";
import {
  EditOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import ConfirmationModal from "../../Common/ConfirmationModal";
import BatchReportsTableNew from "./BatchReportsTableNew";
import { getUser } from "../../../utils/helpers";
import "./BatchReportsPreviewTable.css";
import WoDetailsModal from "./WoDetailsModal";

export default class TempPreviewTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workOrderFontColorList: ["#ea33f7", "#19305a", "#0ac192"],
      previewTableData: {},
      modalObj: {},
      editCustomer: false,
      customerId: "",
      selectPartial: false,
      selectedPartialOBj: {},
      validResultInput: true,
      isWoDetailsModalVisible: false,
      currCustomerInfo: null,
    };
    this.currResultInput = "";
  }

  componentDidMount() {
    const { previewTableData, customerList } = this.props;
    const tableData = { ...previewTableData, info_list: previewTableData.info_list.map((obj) => ({ ...obj })) };
    // set up the striped effect on different sample
    let readyNum = 0;
    let prevIdx = 0;
    tableData.info_list.forEach(
      (item, index) => {
        if (index > 0) {
          if (tableData.info_list[index - 1].genista_id !== item.genista_id) {
            item.grey_color = !tableData.info_list[index - 1].grey_color;
          } else {
            item.grey_color = tableData.info_list[index - 1].grey_color;
          }
        } else {
          item.grey_color = false;
        }

        // compute pending or retest total
        if (index > 0 && tableData.info_list[index - 1].genista_id !== item.genista_id) {
          tableData.info_list[prevIdx].greyoutSample = readyNum === 0;
          tableData.info_list[prevIdx].availableSelect = readyNum;
          tableData.info_list[prevIdx].fixedAvailableSelect = readyNum;
          prevIdx = index;
          readyNum = 0;
        }
        if (item.test_status === "Ready") {
          readyNum += 1;
          item.greyout = false;
        } else {
          item.greyout = true;
        }

        if (index === tableData.info_list.length - 1) {
          tableData.info_list[prevIdx].greyoutSample = readyNum === (index - prevIdx + 1);
          tableData.info_list[prevIdx].availableSelect = readyNum;
          tableData.info_list[prevIdx].fixedAvailableSelect = readyNum;
          tableData.info_list[prevIdx].greyoutSample = readyNum === 0;
        }
        item.headIdx = prevIdx;
        item.edit_result = false;
        item.textareaRef = React.createRef();
      },
    );
    // Find the customer id with matched customer_name, take the first result
    const foundItem = customerList.find((item) => item.label === previewTableData.customer_name);
    this.setState({
      previewTableData: tableData,
      customerId: foundItem ? foundItem.value : "",
      currCustomerInfo: foundItem,
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  handleFilterCustomer = (inputValue, option) => option.label?.toLowerCase().indexOf(inputValue?.toLowerCase()) !== -1;

  handleClickOutside = (event) => {
    const { previewTableData } = this.state;
    let resetInputState = false;
    previewTableData.info_list.every((data) => {
      if (
        data.edit_result
        && data.textareaRef.current
        && !data.textareaRef.current.contains(event.target)
      ) {
        data.edit_result = false;
        resetInputState = true;
        return false;
      }
      return true;
    });
    // update state if needed to avoid to many re-renderings
    if (resetInputState) {
      this.setState({ previewTableData, validResultInput: true });
    }
  };

  /**
   * Display the delete icon when the user hovers in a row
   * Hide the delete icon when the user hovers out a row
   * @param {*} index
   * @param {*} action
   */
  toggleIcon = (index, action, type) => {
    const { previewTableData, selectPartial } = this.state;
    if (selectPartial) {
      return;
    }
    const targetVal = action === "enter";
    if (previewTableData.info_list[index][type] !== targetVal) {
      previewTableData.info_list[index][type] = action === "enter";
      this.setState({ previewTableData });
    }
  }

  /**
   * Set up the modal information and open the Delete Confirmation modal
   * @param {*} action
   * @param {*} data
   */
  handleClick = (action, data) => {
    let bodyText = `Are you sure you want to delete <strong>${data.target}</strong> ?`;
    if (action === "Sample") {
      bodyText += "<br>This will delete all the data related to this sample.";
    }

    const modalObj = {
      title: `Delete ${action}`,
      bodyText,
      workorder_id: data.wo_id,
      genista_id: data.genista_id,
      openModal: true,
    };
    // Set the analysis field if this is a delete test action
    if (data.internal_name) {
      modalObj.analysis = [{ test_name: data.internal_name }];
    }
    this.setState({ modalObj });
  }

  handleCloseModal = () => {
    this.setState({ modalObj: {} });
  }

  /**
   * Create the payload for the editsample/ and make the api call
   */
  handleConfirmDelete = async () => {
    const { handleAfterDeleteConfirm } = this.props;
    const { modalObj } = this.state;
    const isDeleteWo = modalObj.title.toLowerCase().includes("workorder");
    const payload = {
      action: "delete",
      workorder_id: modalObj.workorder_id,
      genista_id: modalObj.genista_id,
    };

    // set the "is_workorder" field if this is a delete workorder field
    if (isDeleteWo) {
      payload.is_workorder = true;
    }

    // Set the analysis field if this is a delete test action
    if (modalObj.analysis) {
      payload.analysis = modalObj.analysis;
    }
    const apiSuccess = handleAfterDeleteConfirm(payload);
    // if delete success, then reset the modalObj
    if (apiSuccess) {
      this.setState({ modalObj: {} });
    }
  }

  /**
   * Handle opening/closing the edit input and make an api call to udpate the customer name
   */
  handleEdit = async (action) => {
    const { handleEditCustomer, customerList } = this.props;
    const { previewTableData, customerId, currCustomerInfo } = this.state;
    if (currCustomerInfo?.option?.billing_mode) {
      return;
    }
    if (action === "open") {
      this.setState({ editCustomer: true });
    } else if (action === "close") {
      // Find the customer id with matched customer_name, take the first result
      const foundItem = customerList.find((item) => item.label === previewTableData.customer_name);
      // when closing the edit input, reset the customer name to its original name
      this.setState({ editCustomer: false, customerId: foundItem ? foundItem.value : "" });
    } else {
      // validate customer name. Name cannot by empty or null
      if (!customerId) {
        toast.error("Invalid Customer");
        return;
      }
      const original_customer_id = customerList.find((item) => item.label === previewTableData.customer_name)?.value ?? "";
      const payload = {
        customer_id: customerId,
        workorder_id: previewTableData.wo_id,
        original_customer_id,
      };
      const addSuccess = await handleEditCustomer(payload);
      // close the edit input only if the api succeeded
      if (addSuccess) {
        this.setState({ editCustomer: false });
      }
    }
  }

  handleSelectPartial = () => {
    this.setState({ selectPartial: true });
  }

  /**
   * Reset states:
   * 1. checkbox value
   * 2. initial total number of ready tests
   * 3. the id-array map
   */
  handleClosePartial = () => {
    const { previewTableData } = this.state;
    previewTableData.info_list.forEach(
      (item, index) => {
        item.sample_check = false;
        item.test_check = false;
        // reset the the initial total number of ready tests
        if (item.headIdx === index) {
          item.availableSelect = item.fixedAvailableSelect;
        }
      },
    );
    this.setState({ selectPartial: false, selectedPartialOBj: {}, previewTableData });
  }

  /**
   * When selecting a sample, we need to set all the Ready tests checkboxes to true. Otherwise, set it to false.
   * @param {*} start
   * @param {*} checkVal
   * @param {*} selectVal
   * @param {*} previewTableData
   */
  setAllTestCheckbox = (start, checkVal, selectVal, previewTableData) => {
    const { selectedPartialOBj } = this.state;
    const targetGid = previewTableData.info_list[start].genista_id;
    // set the ready test number to 0
    previewTableData.info_list[start].availableSelect = selectVal;
    // set the sample checkbox to true
    previewTableData.info_list[start].sample_check = checkVal;
    // set an empty array for the current gid key in the list obj
    selectedPartialOBj[targetGid] = [];

    /** set all Ready tests's checkbox based on the checked value */
    for (let i = start; i < previewTableData.info_list.length; ++i) {
      const currGid = previewTableData.info_list[i].genista_id;
      const currTest = previewTableData.info_list[i].internal_name;
      const skip = previewTableData.info_list[i].greyout;
      // If the current gid != targetGid, then we know we already set all the tests checkboxes
      if (currGid !== targetGid) {
        break;
      }
      // only set the checked value for Ready Test
      if (!skip) {
        if (checkVal) {
          selectedPartialOBj[targetGid].push(currTest);
        }
        previewTableData.info_list[i].test_check = checkVal;
      }
    }

    // If it is an uncheck, then delete the current key to remove all the tests
    if (!checkVal) {
      delete selectedPartialOBj[targetGid];
    }
  }

  /**
   * When selecting a sample, check all the Ready tests' checkbox. Otherwise, set all the Ready tests' checkbox to false
   * @param {*} checked
   * @param {*} index
   * @return
   */
  handleSelectSample = (checked, index) => {
    const { previewTableData } = this.state;
    if (checked === null) {
      return;
    }
    if (checked) {
      this.setAllTestCheckbox(index, true, 0, previewTableData);
    } else {
      this.setAllTestCheckbox(index, false, previewTableData.info_list[index].fixedAvailableSelect, previewTableData);
    }
    this.setState({ previewTableData });
  }

  /**
   * Check/uncheck a test
   * 1. If it is the last Ready test for the current sample, then check the sample
   * @param {*} checked
   * @param {*} index
   * @returns
   */
  handleSelectTest = (checked, index) => {
    if (checked === null) {
      return;
    }
    const { previewTableData, selectedPartialOBj } = this.state;
    const { headIdx, genista_id, internal_name } = previewTableData.info_list[index];
    if (checked) {
      // if the genista id key does not exist, then initiate it
      if (!selectedPartialOBj[genista_id]) {
        selectedPartialOBj[genista_id] = [];
      }
      // only push a new test
      if (!selectedPartialOBj[genista_id].includes(internal_name)) {
        selectedPartialOBj[genista_id].push(internal_name);
      }
      // reduce the ready test total counter
      previewTableData.info_list[headIdx].availableSelect--;
      // if it is the last Ready test, then we check the sample
      if (previewTableData.info_list[headIdx].availableSelect === 0) {
        previewTableData.info_list[headIdx].sample_check = checked;
      }
      previewTableData.info_list[index].test_check = checked;
    } else {
      /** Remove the test from the list and incremenr the Ready Tests total counter */
      const testIdx = selectedPartialOBj[genista_id].indexOf(internal_name);
      selectedPartialOBj[genista_id].splice(testIdx, 1);
      previewTableData.info_list[headIdx].availableSelect++;
      // If all tests are not selected, then remove the gid key in the payload list
      if (previewTableData.info_list[headIdx].availableSelect === previewTableData.info_list[headIdx].fixedAvailableSelect) {
        delete selectedPartialOBj[genista_id];
      }
      // unchekc box sample and test
      previewTableData.info_list[headIdx].sample_check = false;
      previewTableData.info_list[index].test_check = checked;
    }
    this.setState({ previewTableData, selectedPartialOBj });
  }

  /**
   * Make an api call to generate a report for the partial tests
   * @returns
   */
  handleGneratePartialTests = () => {
    const { selectedPartialOBj, previewTableData } = this.state;
    const { handlePartialTestSubmit } = this.props;
    // base case: at lease one test should be selected
    if (Object.keys(selectedPartialOBj).length === 0) {
      toast.warn("Please select a test!");
      return;
    }
    handlePartialTestSubmit(previewTableData.wo_id, selectedPartialOBj);
  }

  handleEditResult = (index) => {
    const { previewTableData } = this.state;
    // set the edit_result to true to turn on textarea for editing
    previewTableData.info_list[index].edit_result = true;
    // set the current test result to the currResultInput state
    this.currResultInput = previewTableData.info_list[index].result;
    this.setState({ previewTableData });
  }

  /**
   * Updates the current input value to the currResultInput state
   * and checks if the current input value has exceeded the 2000-character limit
   * @param {*} e
   */
  handleChangeResultValue = (e) => {
    const { validResultInput } = this.state;
    const valid = e.target.value.length <= 2000;
    // only update the state if it is different than the previous state
    // to avoid too many re-rendering
    if (valid !== validResultInput) {
      this.setState({ validResultInput: valid });
    }
    this.currResultInput = e.target.value;
  };

  /**
   * Create a payload for the update result api, make an api call, update the state if api succeeded
   * @param {*} element
   * @param {*} index
   * @returns
   */
  handleUpdateResult = async (element, targetIdx) => {
    const { previewTableData } = this.state;
    // check empty string input
    if (this.currResultInput === "") {
      toast.warn("Please enter a valid Result value");
      return;
    }
    const { handleUpdateResultApi } = this.props;
    const payload = {
      GenistaID: element.genista_id,
      Analysis: element.internal_name,
      Result: this.currResultInput,
      OrderID: previewTableData.wo_id,
      source: "Automation - Batch Reports - Workorders",
      override: getUser()?.permissionMap?.override_test_result_batchreports ?? false,
    };
    const response = await handleUpdateResultApi(payload);
    /** update the test result to the main state list and change the test status to Ready */
    if (!response.updated_micro_hierarchy_failed_tests || response.updated_micro_hierarchy_failed_tests.length === 0) { // Only update the test result if no hierarchy tests are updated. Otherwise, the preview table will be re-rendered by the parent component.
      previewTableData.info_list[targetIdx].result = this.currResultInput;
      previewTableData.info_list[targetIdx].test_status = response.new_status ? response.new_status : "Ready";
      previewTableData.info_list[targetIdx].edit_result = false;
      this.currResultInput = "";
      // Re-calculate the number of test with "Ready" status
      this.recountReadyNum(previewTableData);
    }
  }

  recountReadyNum = (previewTableData) => {
    let readyNum = 0;
    let prevIdx = 0;
    previewTableData.info_list.forEach(
      (item, index) => {
        if (index > 0) {
          if (previewTableData.info_list[index - 1].genista_id !== item.genista_id) {
            item.grey_color = !previewTableData.info_list[index - 1].grey_color;
          } else {
            item.grey_color = previewTableData.info_list[index - 1].grey_color;
          }
        } else {
          item.grey_color = false;
        }

        // compute pending or retest total
        if (index > 0 && previewTableData.info_list[index - 1].genista_id !== item.genista_id) {
          previewTableData.info_list[prevIdx].greyoutSample = readyNum === 0;
          previewTableData.info_list[prevIdx].availableSelect = readyNum;
          previewTableData.info_list[prevIdx].fixedAvailableSelect = readyNum;
          prevIdx = index;
          readyNum = 0;
        }
        if (item.test_status === "Ready") {
          readyNum += 1;
          item.greyout = false;
        } else {
          item.greyout = true;
        }

        if (index === previewTableData.info_list.length - 1) {
          previewTableData.info_list[prevIdx].greyoutSample = readyNum === (index - prevIdx + 1);
          previewTableData.info_list[prevIdx].availableSelect = readyNum;
          previewTableData.info_list[prevIdx].fixedAvailableSelect = readyNum;
          previewTableData.info_list[prevIdx].greyoutSample = readyNum === 0;
        }
        item.headIdx = prevIdx;
      },
    );
    this.setState({ previewTableData });
  }

  /**
   * Create a textarea for the test result with a Save button
   * @param {*} element
   * @param {*} index
   * @returns
   */
  resultTextArea = (element, index) => {
    const { validResultInput } = this.state;
    const title = validResultInput ? "" : "You've exceeded the 2000-character limit.";

    return (
      <div
        ref={element.textareaRef}
        className="SendReportsPreview__Result__Textarea"
      >
        <Tooltip
          placement="left"
          title={title}
          open={title !== ""}
          overlayClassName="SendReportsPreview__Input__Tooltip"
        >
          <Input.TextArea
            autoSize
            defaultValue={this.currResultInput}
            maxLength={300}
            onChange={(e) => this.handleChangeResultValue(e)}
            status={title !== "" ? "error" : ""}
          />
        </Tooltip>
        <Button
          type="primary"
          className="BatchReportPreview__SaveResultBtn"
          disabled={title !== ""}
          onClick={() => this.handleUpdateResult(element, index)}
        >
          Save
        </Button>
      </div>
    );
  }

  toggleWoDetailsModal = (isVisible) => this.setState((state) => ({ ...state, isWoDetailsModalVisible: isVisible }));

  render() {
    const { handleClosePreview, customerList } = this.props;
    const {
      workOrderFontColorList,
      previewTableData,
      modalObj,
      editCustomer,
      customerId,
      selectPartial,
      isWoDetailsModalVisible,
      currCustomerInfo,
    } = this.state;

    return (
      <>
        <div>
          <div className="batchReportPreviewHeader">
            <div>
              <div className="batchReportPreviewHeaderWorkorder">
                Work order:&nbsp;
                <span
                  className="batchReportPreviewHeaderWorkorder__WoIdWithIcon"
                  style={{ color: workOrderFontColorList[previewTableData.status] }}
                  onClick={() => this.toggleWoDetailsModal(true)}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") this.toggleWoDetailsModal(true); }}
                  role="button"
                  tabIndex={0}
                >
                  <span className="batchReportPreviewHeaderWorkorder__WoId">{previewTableData.wo_id}</span>
                  <EyeOutlined
                    className="batchReportPreviewHeaderWorkorder__EyeIcon"
                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.toggleWoDetailsModal(true); } }}
                    role="button"
                    tabIndex={0}
                    aria-label="View work order details"
                  />
                </span>
                {/* <DeleteOutlined
                className="BatchReportPreview__DeleteIcon--margin-left"
                onClick={() => this.handleClick("Workorder", { wo_id: previewTableData.wo_id, genista_id: previewTableData.info_list[0].genista_id, target: previewTableData.wo_id })}
              /> */}
              </div>
              <div className="batchReportPreviewHeaderCustomerName">
                Customer:&nbsp;
                {!editCustomer && <span className="batchReportPreviewHeaderCustomerName__Span">{previewTableData.customer_name}</span>}
                {editCustomer && (
                <Select
                  allowClear
                  showSearch
                  className="BatchReportPrview__Select"
                  popupClassName="BatchReportPrview__Select__Menu"
                  placeholder="Select Company"
                  value={customerId}
                  options={customerList}
                  filterOption={(inputValue, option) => this.handleFilterCustomer(inputValue, option)}
                  onSelect={(c_id) => this.setState({ customerId: c_id })}
                  onClear={() => this.setState({ customerId: null })}
                  listHeight={320}
                />
                )}
                {!editCustomer && (
                  <Tooltip title={currCustomerInfo?.option?.billing_mode ? "This customer has a valid billing mode and cannot be edited." : ""}>
                    <EditOutlined disabled={currCustomerInfo?.option?.billing_mode} onClick={() => this.handleEdit("open")} className={`${currCustomerInfo?.option?.billing_mode ? "BatchReportPreviewTable__Edit--disabled" : "BatchReportPreviewTable__Edit"}`} />
                  </Tooltip>
                )}
                {editCustomer && <CheckCircleOutlined onClick={() => this.handleEdit("confirm")} className="BatchReportPreviewTable__Check" />}
                {editCustomer && <CloseCircleOutlined onClick={() => this.handleEdit("close")} className="BatchReportPreviewTable__Close" />}
              </div>
            </div>
            <i
              onClick={handleClosePreview}
              className="fa fa-times batchReportClosePreviewIcon"
            />
          </div>

          <Scrollbar
            className="BatchReportPrview__Scrollbar"
            disableTrackYWidthCompensation
            disableTracksWidthCompensation
          >
            <BatchReportsTableNew
              previewTableData={previewTableData}
              showTable={this.showTable}
              selectPartial={selectPartial}
              toggleIcon={this.toggleIcon}
              handleSelectSample={this.handleSelectSample}
              handleClick={this.handleClick}
              handleSelectTest={this.handleSelectTest}
              handleEditResult={this.handleEditResult}
              resultTextArea={this.resultTextArea}
            />
          </Scrollbar>

          <div className="BatchReportPreview__Partial">
            {selectPartial && (
              <Button
                onClick={() => this.handleClosePartial()}
              >
                Cancel
              </Button>
            )}
            {selectPartial && (
              <Button
                type="primary"
                onClick={() => this.handleGneratePartialTests()}
              >
                Generate Partial Tests
              </Button>
            )}
            {!selectPartial && (
              <Button
                type="primary"
                onClick={() => this.handleSelectPartial()}
              >
                Select Partial
              </Button>
            )}
          </div>

          <ConfirmationModal
            title={modalObj.title}
            open={modalObj.openModal}
            bodyText={modalObj.bodyText}
            okText="Delete"
            cancelText="Cancel"
            onCancel={this.handleCloseModal}
            onOk={this.handleConfirmDelete}
            width="auto"
          />
        </div>
        {isWoDetailsModalVisible && (
          <WoDetailsModal
            workorderPk={previewTableData?.wo_id_pk}
            closeModal={() => this.toggleWoDetailsModal(false)}
          />
        )}
      </>
    );
  }
}
